import { render, staticRenderFns } from "./PioneerGames.vue?vue&type=template&id=fd05d9d2&scoped=true&"
import script from "./PioneerGames.vue?vue&type=script&lang=js&"
export * from "./PioneerGames.vue?vue&type=script&lang=js&"
import style0 from "./PioneerGames.vue?vue&type=style&index=0&id=fd05d9d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd05d9d2",
  null
  
)

export default component.exports